import {
  Backdrop,
  Card,
  CardContent,
  CardHeader,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  Grid,
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
  ThemeProvider,
  createMuiTheme,
  Button
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import { productHistoryRequest, getTasksRequest } from 'src/store/actions';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { useHistory } from 'react-router';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  listItem: {
    cursor: 'pointer'
  },
  inner: {
    minWidth: 1150
  },
  methodCell: {
    width: 100
  },
  statusCell: {
    width: 64
  },
  baslik: {
    padding: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));
const siyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});

function ProductBom({ tasks }) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const history = useHistory();
  const [productBomDate, setProductBomDate] = useState(null)

  const locale = localStorage.getItem('i18nextLng');

  useEffect(() => {
    console.log(tasks)
  }, [])

  const localeMap = {
    tr: trLocale
  };

  return (
    <div>
      <Card>
        <CardHeader title={t('lblProductBom')}
          action={
            <Grid container spacing={2}>
              <Grid item  xs={12} sm={12} lg={12}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localeMap[locale]}
                  >
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      id="orderDate"
                      size="small"
                      invalidDateMessage={t('hatali_tarih')}
                      format="dd.MM.yyyy"
                      fullWidth
                      autoComplete="off"
                      label={t('lblBomDate')}
                      variant="outlined"
                      value={productBomDate}
                      onChange={e => setProductBomDate(e)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <Button
                  variant="contained"
                  color="secondary"
                  // onClick={() => { updateAsset() }}
                  fullWidth
                >
                  {t('lblSearch')}
                </Button>
              </Grid>
            </Grid>
          }
        />
        <Divider />

        <CardContent className={classes.content}>

          <Grid container spacing={1}>
            <Grid item xs={12} align="left">
              <TableContainer className={classes.table} component={Paper}>
                <Table size="small" aria-label="defect table">
                  <TableBody>

                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>

        </CardContent>
      </Card>
    </div>
  );
}

ProductBom.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({
    productHistoryReducer: state.productHistoryReducer
  }),
  {
    productHistoryRequest,
    getTasksRequest
  }
)(ProductBom);
